import { render } from "./Loading.vue?vue&type=template&id=33849f7c"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=33849f7c&lang=scss"
script.render = render

export default script